import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Slide, TextField, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import { forwardRef, useState } from "react";
import { country } from "../booking/country";
import { getPinCodeJsr, validIndianPin } from "../booking/booking_halper";
import { orgLocationUpdate } from "./edit_halper";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function LocationEdit({ data, open, handleClose, onSuccess }) {
    const [inputErrors, setInputErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleSelfClose = () => {
        if (isLoading) return;
        setInputErrors({});
        setIsLoading(false);
        handleClose();
    }

    const handleSelfSubmit = (event) => {
        event.preventDefault();
        const frm_data = new FormData(event.currentTarget);
        const pincode = frm_data.get("pincode");
        const destination = frm_data.get("destination");
        const country = frm_data.get("country");
        const address = frm_data.get("address");
        var flag = true;
        if (country === "India" && __error_handler(validIndianPin(pincode), "pincode", "Please fill a valid pincode.")) {
            flag = false;
        }
        setIsLoading(true);
        if (flag) {
            const _json = { "cn": data.cn_no, "destination": destination, "address": address, "country": country, "pincode": pincode };
            orgLocationUpdate(_json).then((_) => {
                if (onSuccess) onSuccess({ "task": "location", ..._json });
                handleSelfClose();
            }).catch((err) => {
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handlePincodeChange = (event) => {
        const pincode = event.target.value;
        const valid = validIndianPin(pincode);
        __error_handler(valid, "pincode", "Please fill a valid pincode.");
        if (valid) {
            setIsLoading(true);
            getPinCodeJsr(pincode).then((res) => {
                setIsLoading(false);
            }).catch((err) => {
                setIsLoading(false);
                console.error(err);
            });
        }
    }

    if (data === null) return (<></>);
    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} keepMounted component="form" onSubmit={handleSelfSubmit}>
            <DialogTitle variant="h5" color="info">{data.cn_no}</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption">Location Correction</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField variant="outlined" name="pincode" defaultValue={data.pincode} fullWidth autoFocus error={inputErrors.pincode} type="text" helperText={inputErrors.pincode} placeholder="Pincode" label="Pincode" onChange={handlePincodeChange} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField variant="outlined" name="destination" defaultValue={data.destination} fullWidth error={inputErrors.destination} type="text" helperText={inputErrors.destination} placeholder="Destination" label="Destination" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Autocomplete
                            disablePortal
                            options={country}
                            defaultValue={data.country}
                            renderInput={(params) => <TextField {...params} variant="outlined" name="country" fullWidth error={inputErrors.country} type="text" helperText={inputErrors.country} placeholder="Consigment Number" label="Country" />}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <TextField variant="outlined" name="address" defaultValue={data.address} fullWidth error={inputErrors.address} type="text" multiline rows={3} helperText={inputErrors.address} placeholder="Address" label="Address" />
                    </Grid>
                </Grid>
            </DialogContent>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button variant="outlined" disabled={isLoading} onClick={handleSelfClose}>Cancel</Button>
                <Button variant="contained" disabled={isLoading} color="warning" type="submit">Save</Button>
            </DialogActions>
        </Dialog>
    );
}
export default LocationEdit;